export const configs = {
  webLinkageLinksAndInfo: {
    key: 'web_linkage_links_and_info',
    defaultValue: `{
      "virgo_web_url": "https://virgoku.id"
    }`,
  },
  webLinkageMaintenanceMode: {
    key: 'web_linkage_maintenance_mode',
    defaultValue: 'off',
  },
  linkageLogin: {
    key: 'linkage_login',
    defaultValue: 'off',
  },
  oneTimePaymentLogin: {
    key: 'one_time_payment_login',
    defaultValue: 'off',
  },
};

export type RemoteConfigParam = keyof typeof configs;
